<template>
<div>
  {{countDownText}}
</div>
</template>
<script>
export default{
  props: ['startTime', 'duration', 'status','meetingTitle'],
  data () {
    return {
      interval: '',
      timeLeft: this.$moment.duration(0)
    }
  },
  computed: {
    countDownText () {
      var moment = this.$moment.utc(this.timeLeft.as('milliseconds'))
      // return moment.format('HH:mm')
      // console.log(this.timeLeft.asMilliseconds() )
      if (this.timeLeft.asMilliseconds() <= 0) {
        return '00:00:00'
      }
      else if (this.timeLeft.asMilliseconds() < 3600000) { // 1 hour
        return moment.format('mm:ss')
      }
      else  {
        return moment.format('HH:mm:ss')
      }
      // else if (this.timeLeft.asMilliseconds() < 300000) {  // 5 minutes
      //   return moment.format('HH:mm:ss')
      // } else {
      //   return moment.add('m', 1).format('HH:mm') // Add 1 minute to make it look right
      // }
    }
  },
  methods: {
    updateCountDown () {
      var elapsedTimeMillis = new Date().getTime() - new Date(this.startTime).getTime()
      // console.log('elapsedTimeMillis=' + elapsedTimeMillis)
      this.timeLeft = this.$moment.duration(parseInt(this.duration), 'm').subtract(elapsedTimeMillis)
      // document.title = this.$moment.utc(this.timeLeft.as('milliseconds')).format('HH:mm:ss') + ' ' + this.meetingTitle
      document.title = this.countDownText + ' ' + this.meetingTitle
      // if (this.timeLeft.asMilliseconds() <= 0) {
      //   clearInterval(this.interval)
      // } else if (this.timeLeft.asMilliseconds() <= 300000) {
      //   clearInterval(this.interval)
      //   this.interval = setInterval(() => this.updateCountDown(), 1000)
      // }
    }
  },
  destroyed: function () {
    console.log('Clear Interval')
    clearInterval(this.interval)
  },
  watch: {
    status: function (newVal, oldVal) {
      console.log('newVal=' + newVal)
      if (newVal === 'started') {
        console.log('Start timer')
        this.updateCountDown()
        // this.interval = setInterval(() => this.updateCountDown(), 15000)
        this.interval = setInterval(() => this.updateCountDown(), 1000)
      } else if (newVal === 'ended') {
        console.log('Stop Timer')
        clearInterval(this.interval)
        console.log('stopped timer')
      }
    }
  }
}
</script>
